import ListItemId from '@/components/Tours/ListItemId'
import ListItemLabel from '@/components/Tours/ListItemLabel'
import ListItemStops from '@/components/Tours/ListItemStops'

export default {
  computed: {
    toursModel() {
      return {
        title: 'Tours',
        endpoint: this.$appConfig.api.baseUrl + 'tours',
        listExtrasComponent: () => import('@/components/Tours/ListExtras'),
        allowNew: false,
        allowSelect: true,
        countrize: 'country_iso_code',
        fields: [
          {
            key: 'id',
            sortable: true,
            label: this.$gettext('ID'),
            component: (value, key, item) => {
              return {
                is: ListItemId,
                tour: item
              }
            }
          },
          {
            key: 'label',
            sortable: true,
            label: this.$gettext('Label'),
            component: (value, key, item) => {
              return {
                is: ListItemLabel,
                tour: item
              }
            }
          },
          {
            key: 'optimized',
            sortable: false,
            label: this.$gettext('Optimized')
          },
          {
            key: 'courier',
            sortable: true,
            editable: true,
            label: this.$gettext('Courier'),
            component: (value, key, item) => {
              return {
                is: 'user-card',
                user: item.courier || {},
                profilePicture: false,
                withTitles: false
                // " :vehicle-types-prop="vehicleTypes"
              }
            }
          },
          {
            key: 'status',
            sortable: true,
            editable: true,
            label: this.$gettext('Status')
          },
          {
            key: 'stops',
            sortable: false,
            editable: false,
            label: this.$gettext('Visits'),
            component: (value, key, item) => {
              return {
                is: ListItemStops,
                tour: item
              }
            }
          },
          {
            key: 'comment',
            sortable: false,
            editable: false,
            label: this.$gettext('Comment')
          },
          {
            key: 'created_at',
            sortable: true,
            editable: false,
            label: this.$gettext('Created At'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'updated_at',
            sortable: true,
            editable: false,
            label: this.$gettext('Last Updated'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          }
        ],
        extraActions: [
          {
            label: '',
            type: () => import('@/components/Tours/ListItemActions'), // external bunch of actions
            position: 'start',
            props: (item) => {
              return {
                tour: item
              }
            }
          },
          {
            type: 'b-dropdown-divider',
            position: 'start'
          }
        ],
        filters: [
          'id',
          'label',
          'courier_id',
          'status',
          'created_at'
        ],
        includes: [
          'shippings',
          'visits',
          'courier.courier_available.tracking',
          'courier.roles',
          'courier.company',
          'fixed_amount_price_schedules.fixed_tour'
        ],
        exclude: [
          'optimized',
          'comment'
        ]
      }
    }
  }
}
